'use es6';

import { FetchHsfsRequestTypes } from '../actions/HsfsActions';
const initialState = {};

const hsfs = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case FetchHsfsRequestTypes.RECEIVE:
      {
        const {
          data
        } = payload;
        return data;
      }

    default:
      return state;
  }
};

export default hsfs;